// extracted by mini-css-extract-plugin
export default {"container":"footballRush_container__Bn3eV","loading":"footballRush_loading__p7M9c","outerBox":"footballRush_outerBox__hlpXO","innerBox":"footballRush_innerBox__DDaHU"};